import { ValidationErrorData } from './common';
import { Goal } from './goals';

export interface MetrikaKeyGoalsEditorData {
    isOpen: boolean;
    selectedGoals: MetrikaSelectedKeyGoal[];
    isMetrikaAvailable: boolean;
}

export type MetrikaKeyGoalsEditorState = Record<
    string,
    MetrikaKeyGoalsEditorData
>;

export interface MetrikaKeyGoalsValue {
    selectedGoals: MetrikaSelectedKeyGoal[];
}

export interface MetrikaSelectedKeyGoal {
    id: string;
    conversionValue: string;
    errors: MetrikaKeyGoalValidationData;
}

export interface MetrikaKeyGoalValidationData {
    goal: ValidationErrorData[];
    conversionValue: ValidationErrorData[];
}

export interface MetrikaKeyGoalsEditorValidationResult {
    isValid: boolean;
    keyGoalsValidationData: MetrikaKeyGoalValidationData[];
}

export interface MetrikaKeyGoalItem extends MetrikaSelectedKeyGoal {
    name: string;
}

export interface MetrikaKeyGoalDropdownItem extends Goal {
    isDisabled: boolean;
}

export interface MetrikaKeyGoalsDropdownParams {
    goalsDropdownItems: MetrikaKeyGoalDropdownItem[];
    selectedGoalsItems: MetrikaKeyGoalItem[];
}

export enum MetrikaKeyGoalSpecialId {
    unavailable = 'unavailable',
    chooseGoal = 'chooseGoal'
}
